import React from 'react';
import {
  RtbCampaignSetupFlowPageProps,
  RtbCampaignSetupFlowPageState,
} from './RtbCampaignSetupFlowPageModel';
import { RouteComponentProps, Redirect } from 'react-router-dom';
import { LoadingIndicator } from 'components/LoadingIndicator';
import NavigationPrompt from 'components/NavigationPrompt/NavigationPrompt';
import { StepPage } from 'containers/StepPage/StepPage';
import { ChooseAdTypeStep } from './FlowSteps/ChooseAdTypeStep';
import { RtbCampaignSetupStep } from './FlowSteps/RtbCampaignSetupStep';
import { RtbCampaignSummaryStep } from './FlowSteps/RtbCampaignSummaryStep';
import { DefaultChooseAdTypeStepModel } from './FlowSteps/ChooseAdTypeStepModel';
import { DefaultRtbCampaignSetupStepModel } from './FlowSteps/RtbCampaignSetupStepModel';
import styles from './rtbCampaignSetupFlowPage.module.scss';
import i18n from 'i18n';
import { AppFooter } from 'components/AppFooter';
import { DynamicBreadcrumb } from 'components/Breadcrumbs/DynamicBreadcrumbs';
import { TitleWithBreadcrumbs } from 'components/TitleArea/TitleWithBreadcrumbs';
import _ from 'lodash';
import { ChooseProductsStep } from './FlowSteps/ChooseProductsStep';
import { alertMessage } from 'components/AlertDialog';
import { RtbCampaignBasic } from 'core/rtbCampaign/RtbCampaign';
import { SmartCampaignConfig } from 'core/configuration/SmartCampaignConfig';
import { SelectSmartConfigStep } from './FlowSteps/SelectSmartConfigStep';
import { Product } from 'core/product/Product';
import { CreativeSetupStep } from './FlowSteps/CreativeSetupStep';
import { CreateCreativeInL2ObjectSetupFlowPageModel } from 'containers/Creatives/CreativeSetupFlow/CreativeSetupFlowPageModel';
import { ChooseMaxCVRProductsStep } from './FlowSteps/ChooseMaxCVRProductsStep';
import { ProductListDataContext } from 'containers/RetailMomo/Products/ProductListDataContext';

export class RtbCampaignSetupFlowPage extends React.Component<
  RouteComponentProps<{}> & RtbCampaignSetupFlowPageProps,
  RtbCampaignSetupFlowPageState
> {
  handler: any;

  componentDidMount() {
    this.handler = this.props.model.event.add((model) => {
      this.setState(model.state);
    });
    this.props.model.initWithErrorHandler();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.model !== this.props.model) {
      prevProps.model.event.remove(this.handler);
      this.handler = this.props.model.event.add((model) => {
        this.setState(model.state);
      });
      this.props.model.initWithErrorHandler();
    }
  }

  componentWillUnmount() {
    this.props.model.onUnmount(this.handler);
  }

  onPromptCancel = () => {
    this.props.model.setRedirectPath(undefined);
  };

  renderTitle = () => {
    const getTitleHint = () => {
      if (!this.props.model.state.smartCampaignConfig) {
        return <div />;
      }
      return (
        <div className={styles.capsule}>
          {i18n.t<string>('campaign.labels.smartConfigHint')}
        </div>
      );
    };
    return (
      <div className={styles.topArea}>
        <TitleWithBreadcrumbs
          title={this.props.model.getTitle()}
          routes={[
            {
              path: '/orders',
              breadcrumb: i18n.t<string>('orderHome.labels.title'),
            },
            {
              path: '/orders/:orderNumber',
              breadcrumb: DynamicBreadcrumb,
              props: {
                label: _.get(this.props.model.order, 'projectName'),
                matchParam: 'orderNumber',
              },
            },
            {
              path: '/orders/:orderNumber/campaigns/new',
              breadcrumb: this.props.model.getTitle(),
            },
            {
              path: '/orders/:orderNumber/campaigns/:campaignId/edit',
              breadcrumb: DynamicBreadcrumb,
              props: {
                prefix: this.props.model.getTitle(),
                label: _.get(this.props.model.state.campaign, 'basic.name'),
                matchParam: 'campaignId',
              },
            },
          ]}
          hint={getTitleHint()}
        />
      </div>
    );
  };

  renderAdTypeStep = ({ goNext }) => {
    this.props.model.setSmartCampaignConfig(undefined);
    return (
      <>
        {this.renderTitle()}
        <div className={styles.contentContainer}>
          <ChooseAdTypeStep
            model={new DefaultChooseAdTypeStepModel(this.props.model, goNext)}
          />
        </div>
      </>
    );
  };

  renderProductList = ({ goNext, goLast, lockRemainSteps }) => {
    return (
      <ChooseProductsStep
        goNext={goNext}
        goLast={goLast}
        lockRemainSteps={lockRemainSteps}
        flowModel={this.props.model}
      />
    );
  };
  renderMaxCVRProductList = ({ goNext, goLast, lockRemainSteps }) => {
    const products = this.props.model.state.campaign.products;
    const autoProducts = this.props.model.state.campaign.autoProducts;

    return (
      // <div>智能投放3.0 智能選品</div>
      <>
        {this.renderTitle()}
        <ProductListDataContext.Provider
          value={{
            selectedProducts: this.props.model.state.campaign.products,
            autoSelectedProducts: this.props.model.state.campaign.autoProducts,
            smartCampaignConfig: this.props.model.state.smartCampaignConfig,
            handleSelectedProducts: (
              fn: (products: Product[]) => Product[],
            ): void => {
              this.props.model.state.campaign.products = fn(products);
            },
            handleAutoSelectedProducts: (
              fn: (autoProducts: Product[]) => Product[],
            ) => {
              this.props.model.state.campaign.autoProducts = fn(autoProducts);
            },
            handleFilterChanged: () => {},
          }}
        >
          <ChooseMaxCVRProductsStep
            goNext={goNext}
            goLast={goLast}
            lockRemainSteps={lockRemainSteps}
            flowModel={this.props.model}
          />
        </ProductListDataContext.Provider>
      </>
    );
  };

  renderMainStep = ({
    subStepIndex,
    goSubStep,
    goNext,
    goLast,
    registerValidateMethod,
  }) => {
    return (
      <>
        {this.renderTitle()}
        <div className={styles.contentContainer}>
          <RtbCampaignSetupStep
            model={
              new DefaultRtbCampaignSetupStepModel(
                this.props.model,
                subStepIndex,
                goSubStep,
                goNext,
                goLast,
                registerValidateMethod,
              )
            }
          />
        </div>
      </>
    );
  };

  renderSmartKeywordMainStep = ({
    subStepIndex,
    goSubStep,
    goNext,
    goLast,
    registerValidateMethod,
  }) => {
    return (
      <>
        {this.renderTitle()}
        <div
          className={`${styles.contentContainer} ${styles.smartKeywordMainStep}`}
        >
          <RtbCampaignSetupStep
            model={
              new DefaultRtbCampaignSetupStepModel(
                this.props.model,
                subStepIndex,
                goSubStep,
                goNext,
                goLast,
                registerValidateMethod,
              )
            }
          />
        </div>
      </>
    );
  };

  renderCVRSmartKeywordMainStep = ({
    subStepIndex,
    goSubStep,
    goNext,
    goLast,
    registerValidateMethod,
  }) => {
    this.props.model.setSmartCampaignConfig(undefined);
    return (
      <>
        {this.renderTitle()}
        <div
          className={`${styles.contentContainer} ${styles.smartKeywordMainStep}`}
        >
          <RtbCampaignSetupStep
            model={
              new DefaultRtbCampaignSetupStepModel(
                this.props.model,
                subStepIndex,
                goSubStep,
                goNext,
                goLast,
                registerValidateMethod,
              )
            }
          />
        </div>
      </>
    );
  };

  renderSmartConfigStep = ({ goLast }) => {
    const { smartCampaignConfigs } = this.props.model.state;

    const goMainStep = (
      config: SmartCampaignConfig,
      campaign: {
        basic: Partial<RtbCampaignBasic>;
        limitations: any;
        products?: Product[];
      },
    ) => {
      this.props.model.onAdTypeChange(config.adType);
      this.props.model.setSmartCampaignConfig(config);
      this.props.model.setCampaign({
        basic: {
          ...this.props.model.state.campaign.basic,
          ...campaign.basic,
        },
        limitations: {
          ...this.props.model.state.campaign.limitations,
          ...campaign.limitations,
        },
        products: campaign.products,
      });
    };

    return (
      <>
        {this.renderTitle()}
        <div
          className={`${styles.contentContainer} ${styles.selectSmartConfigStep}`}
        >
          <SelectSmartConfigStep
            advertiserId={this.props.model.order.advertiserId}
            configs={smartCampaignConfigs}
            goLast={goLast}
            goNext={goMainStep}
          />
        </div>
      </>
    );
  };

  renderSetupCreativeStep = (
    createCreativeModel: CreateCreativeInL2ObjectSetupFlowPageModel,
    { goNext, goLast },
  ) => {
    const creative = createCreativeModel.state.creative;
    if (!creative) {
      return <div />;
    }
    return (
      <>
        {this.renderTitle()}
        <div className={styles.contentContainer}>
          <CreativeSetupStep
            goNext={goNext}
            goLast={goLast}
            model={createCreativeModel}
          />
        </div>
      </>
    );
  };

  renderSummaryStep = ({ goLast, goStep, goSubStep, subStepIndex }) => {
    const createCreativeModel = this.props.model.getCreativeSetupFlowModel();
    const creativeSummaryModel = createCreativeModel
      ? createCreativeModel.getCreativeSummaryModel(goLast, goStep)
      : undefined;
    if (createCreativeModel && creativeSummaryModel) {
      creativeSummaryModel.initContextData({
        creative: createCreativeModel.creative,
        initCreative: createCreativeModel.initCreative,
        advertisers: createCreativeModel.advertisers,
        supportedCreativeType: createCreativeModel.supportedCreativeType,
        setCreative: createCreativeModel.setCreative,
        setFinishedRedirectData: createCreativeModel.setFinishedRedirectData,
        getFormContentModelOfType:
          createCreativeModel.getFormContentModelOfType,
        getSummaryModel: createCreativeModel.getSummaryModel,
      });
    }
    return (
      <>
        {this.renderTitle()}
        <div className={styles.contentContainer}>
          <RtbCampaignSummaryStep
            model={this.props.model.getRtbCampaignSummaryStepModel(
              goLast,
              goStep,
              goSubStep,
              subStepIndex,
              creativeSummaryModel,
            )}
          />
        </div>
      </>
    );
  };

  render() {
    const model = this.props.model;
    const redirectPath = model.state.redirectPath;
    if (!model.state.campaign) {
      return <LoadingIndicator />;
    }
    const createCreativeModel = model.getCreativeSetupFlowModel();
    return (
      <div className={styles.campaignSetupFlowPages}>
        {model.state.loading && <LoadingIndicator />}
        {model.state.showRetry &&
          alertMessage(
            i18n.t<string>('common.titles.error'),
            i18n.t<string>('common.messages.retryFetchData'),
            this.props.model.initWithErrorHandler,
          )}
        <NavigationPrompt
          when={!model.state.finished}
          onCancel={this.onPromptCancel}
        />
        <StepPage
          noLock={this.props.model.type !== 'create'}
          cancel={this.props.model.cancel}
        >
          {this.props.model.type === 'create' && (
            <StepPage.Step
              label={i18n.t<string>('campaign.labels.adType')}
              renderStepContent={this.renderAdTypeStep}
            />
          )}
          {model.isSmartConfig && (
            <StepPage.Step
              label={i18n.t<string>('campaign.labels.selectSmartConfig')}
              renderStepContent={this.renderSmartConfigStep}
            />
          )}
          {model.needSelectProduct && !model.isCVRSmartKeyword && (
            <StepPage.Step
              label={i18n.t<string>('campaign.labels.selectProduct')}
              renderStepContent={this.renderProductList}
            />
          )}
          {model.needSelectProduct && model.isCVRSmartKeyword && (
            <StepPage.Step
              label={i18n.t<string>('campaign.labels.selectProduct')}
              renderStepContent={this.renderMaxCVRProductList}
            />
          )}
          {model.isSmartKeyword ? (
            <StepPage.Step
              label={i18n.t<string>('campaign.labels.campaignSetting')}
              renderStepContent={this.renderSmartKeywordMainStep}
            />
          ) : model.isCVRSmartKeyword ? (
            <StepPage.Step
              label={i18n.t<string>('campaign.labels.campaignSetting')}
              renderStepContent={this.renderCVRSmartKeywordMainStep}
            />
          ) : (
            <StepPage.Step
              label={i18n.t<string>('campaign.labels.campaignSetting')}
              renderStepContent={this.renderMainStep}
            >
              <StepPage.SubStep
                label={i18n.t<string>('stepSideBar.labels.targeting')}
              />
              <StepPage.SubStep
                label={i18n.t<string>('stepSideBar.labels.basic')}
              />
            </StepPage.Step>
          )}
          {createCreativeModel && (
            <StepPage.Step
              label={i18n.t<string>('stepSideBar.labels.creativeSetUp')}
              renderStepContent={_.partial(
                this.renderSetupCreativeStep,
                createCreativeModel,
              )}
            />
          )}
          {createCreativeModel ? (
            <StepPage.Step
              label={i18n.t<string>('campaign.labels.summary')}
              renderStepContent={this.renderSummaryStep}
            >
              <StepPage.SubStep
                label={i18n.t<string>(
                  'stepSideBar.labels.campaignSettingSummary',
                )}
              />
              <StepPage.SubStep
                label={i18n.t<string>(
                  'stepSideBar.labels.creativeSettingSummary',
                )}
              />
            </StepPage.Step>
          ) : (
            <StepPage.Step
              label={i18n.t<string>('campaign.labels.summary')}
              renderStepContent={this.renderSummaryStep}
            />
          )}
          <StepPage.SideBarFooter>
            <AppFooter />
          </StepPage.SideBarFooter>
        </StepPage>
        {redirectPath && <Redirect to={redirectPath} />}
      </div>
    );
  }
}
